export default {
    "label.update_translations_unsuccessful": "{count} פרטים נכשלו:",
    "global.no_records": "אין רישום",
    "notifications.rp_has_been_updated": "פרויקט קהילתי עודכן",
    "moduleTitle.files": "קבצים",
    "label.coordinator": "רכז/ת",
    "sidebar.translations_managment": "ניהול תרגומים",
    "table.file": "קובץ",
    "label.report_overview": "מבט על",
    "label.parent_agreement": "אישור הורים להדפסה",
    "parentalConsent.i_consent_to_and_understand_that": "6. אני מאשר/ת לצלם את החניך/ה בזמן פעילותו/ה במסגרת 'אות הנוער'. אני מאשר/ת לעשות שימוש שיווקי בתיעוד/ תמונות אלו.  \nטופס אישור הורים רלבנטי נחתם על ידי והועבר על ידי החניך/ה למדריך/ה שלו/ה.",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "12. אני מבינ/ה שמשתתפים/ות נדרשים לעמוד בדרישות ה'אות' הכלולות באפליקצת המידע הארגונית (אות\"ה) ",
    "table.end_date": "תאריך סיום",
    "label.activation_date": "תאריך הפעלה",
    "label.report": "דוח",
    "label.award_is_offline": "אות במצב לא מקון",
    "label.pending_changes": "שינויים ממתינים",
    "errors.min_nights_required": " כמות מינימום של {nights} לילות הכרחית",
    "label.country": "מדינה",
    "notifications.award_leader_has_been_returned": "הרכז/ת- מדריך/כה עבר/ה בקרה",
    "notifications.participant_has_been_updated": "משתתף/פת עודכן/ה",
    "label.phone_number": "מספר טלפון",
    "roles.aj_assessor": "מדריך/ת מסע אתגרי",
    "notifications.person_state_has_been_changed": "מידע משתתף שונה",
    "pageTitle.dashboard": "מסך נתונים ראשי",
    "moduleTitle.global_payment_method": "צורת התשלום",
    "label.organization_type": "סוג הסניף",
    "button.account_settings": "הגדרות חשבון",
    "notifications.contact_has_been_updated": "איש/אשת קשר עודכן/ה",
    "participant.recover_password": "שחזור סיסמה",
    "notifications.assessment_request_has_been_sent": "בקשת הערבה נשלחה",
    "button.unassign": "לא משובץ",
    "label.start_date": "תאריך התחלה",
    "label.assign_labels": "הקצה תגיות",
    "sidebar.participants": "משתתפים/ות",
    "roles.coordinator": "רכז/ת",
    "label.organization_contact": "איש קשר של הארגון",
    "tabs.customization": "התאמה אישית",
    "sidebar.award_units": "סניפי אות הנוער",
    "button.change_goal": "שנה/י יעד",
    "translationsManagement.selectProject": "ניהולתרגום.תצורה.בחירתפרויקט",
    "award.rp": "פרויקט קהילתי",
    "label.size": "גודל",
    "label.bulk_action_results": "תוצאות השינוי",
    "notifications.activity_has_been_approved": "פעילות אושרה",
    "label.payment_type": "סוג תשלום",
    "button.gop_assignment": "ציוות GOP",
    "button.resend_assessment_request": "לשליחה מחדש - בקשה הערכה",
    "notifications.template_has_been_removed": "תבנית הוסרה",
    "button.award_settings": "הגדרות האות",
    "pageTitle.payment": "תשלום",
    "tasks.return_award": "בקר/י אות",
    "label.link": "קישור",
    "moduleTitle.award_participant_delete": "מחק אות של החניך",
    "pageTitle.mro_related_contacts": "הסניף שלי - אנשי קשר רלבנטים",
    "pageTitle.my_organization_labels": "הארגון שלי - תגיות",
    "tabs.activity_signoff": "אישור סופי למקטע",
    "table.logs": "רישומים",
    "moduleTitle.remove_file": "להסיר קובץ?",
    "label.email_confirmed": "כתובת דוא\"ל אושרה",
    "notifications.activity_has_been_returned": "פעילות עברה בקרה",
    "label.note": "הערה",
    "button.show": "הצג",
    "tabs.adventurous_journey": "מסע אתגרי",
    "sidebar.my_todolist": "משימות שלי",
    "label.here": "כאן",
    "organisation.change_award_mode": "שנה מצב האות",
    "table.note_from_al": "הערת רכז/ת ",
    "label.gender": "מין",
    "moduleTitle.remove": "להסיר?",
    "errors.must_be_less_than": "חייב להיות פחות מ {limit} ",
    "button.logout": "התנתק/י",
    "label.no_selected_participants": "לא נבחר חניך/ה",
    "button.new_aj_event": "מסע אתגרי- אירוע חדש",
    "label.employement_status": "מצב תעסוקתי",
    "tabs.logs": "רישומים",
    "tabs.contacts": "אנשי/ נשות קשר",
    "label.option": "אפשרות",
    "dashboard.charts": "תרשימים",
    "notifications.rp_has_been_approved": "פרויקט קהילתי אושר לביצוע",
    "pageTitle.new_participant": "חניכים/ות חדשים/ות",
    "notifications.award_leader_has_been_approved": "הרכז/ת - מדריך/כה אושר/ה",
    "moduleTitle.would_you_like_to_remove_leader_training": "האם את/ה מעוניין/ת להסיר הכשרת רכז/ת?",
    "moduleTitle.update_configuration_value": "עדכון תצורת ערך",
    "table.description": "תיאור",
    "table.organization": "ארגון",
    "label.youtube": "יו טיוב",
    "label.author": "מחבר",
    "table.suitable_for_award_level": "מתאים/ה לשלב",
    "label.content_update": "אנא המתן/י. מעלה נתונים",
    "notifications.new_question_has_been_added": "שאלה חדשה נוספה",
    "pageTitle.nao_awards": "מפעיל ארצי (מטה)- אותות",
    "table.last_name": "שם משפחה",
    "moduleTitle.adventurous_journey_detail": "פרטי מסע",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": "אשר לכולם"},
    "label.project_location_type": "סוג מיקום פרויקט",
    "label.email_help_award_level": "שלב באות.",
    "label.date": "תאריך",
    "label.previous_completed_award_place": "איפה",
    "button.show_more": "הצג עוד",
    "label.wwc_number": "מספר WWC",
    "button.filter": "סינון",
    "notifications.rp_has_been_returned": "פרויקט קהילתי עבר בקרה",
    "pageTitle.residetial_project_assessor_report": "פרויקט קהילתי - דיווח מדריך/ה",
    "label.generating": "אוסף נתונים",
    "moduleTitle.finance_system_data": "נתוני מערכת הכספים",
    "notifications.adventurous_journey_state_has_been_changed": "מדינת מסע אתגרי שונתה",
    "route.levels": "שלבים",
    "moduleTitle.activity_leader": "מדריך/ת פעילות",
    "tasks.approve_event": "אשר/י אירוע",
    "tasks.reject_event": "בקר/י אירוע",
    "table.region": "מחוז",
    "pageTitle.nao_award_leaders": "מפעיל ארצי (מטה) - רכזים",
    "errors.must_be_at_least": "יכול להכיל לא פחות מ {min} תווים",
    "table.title": "תואר",
    "table.last_activity": "פעילות אחרונה",
    "tasks.delete_registration": "ביטול הרשמה",
    "table.date_time": "תאריך / זמן",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "14. מפעילי 'אות הנוער' מחויבים לכבד את פרטיותך. מידע אישי נאסף בטופס זה לצורך השתתפות בפעילות 'אות הנוער'. אין באפשרות משתתפים שאינם מספקים לנו מידע זה  להשתתף בפעילות (שים לב שהדבר אינו חל על אי-מתן נתונים של משתתפים). אנו עשויים גם להשתמש במידע האישי שלך כדי לשלוח לך מידע על פעילויות או אירועים אחרים של אות הנוער, אשר לדעתנו עשויים לעניין אותך. אנו עשויים לחשוף מידע זה לארגונים מקומיים או בינלאומיים אחרים ולספקי שירות המסייעים לנו בפעולה ובניהול של הפרס. אם ברצונכם ליצור איתנו קשר או לגשת למידע האישי שלכם, אנא פנו למפעיל הפרס. ניתן גם ליצור קשר עם מפעיל הפרס כדי לבקש עותק של מדיניות הפרטיות שלהם.",
    "aj.practice_journey": "מסע אימון",
    "notification.log_has_been_restored": "תיעוד הפעילויות שוחזר",
    "tabs.my_participants": "המשתתפים/ות שלי",
    "label.bulk_action_assign_label": "הקצה תג",
    "moduleTitle.supervisor": "מפקח/ת",
    "moduleTitle.your_parental_consent": "הסכמת הורים",
    "route.registration_participants": "רישום משתתפים/ות",
    "placeholder.start_typing": "התחל/ התחילי להקליד",
    "tasks.approve_award": "אשר/י אות",
    "route.registrations": "רישום",
    "button.add_activity": "הוסף פעילות",
    "notifications.aj_event_has_been_created": "אירוע מסע אתגרי נוצר",
    "states.supervisor_approval": "אישור מדריך/כה",
    "label.description": "תיאור",
    "button.leave_anyway": "לעזוב בכל זאת",
    "tabs.registrations": "הרשמות",
    "states.leader_signoff": "אזור אימות",
    "moduleTitle.forbidden": "אסור",
    "notifications.translations_has_been_updated.button": "עדכונים.תרגום_עודכן_בהצלחה.כפתור",
    "pageTitle.nao_registration": "מפעיל ארצי (מטה) - רישום",
    "pageTitle.mro_logs": "הסניף שלי - רישומים",
    "meta.page_not_found": "העמוד לא נמצא",
    "label.bulk_action_unsuccessful": "שינוי נכשל ב{count}",
    "global.days": "ימים",
    "table.review": "בדיקה",
    "table.as_assessor_for": "פרטי מדריכ/ה",
    "roles.if_staff_statistical_user": "משתמש מנתח סטטיסטי",
    "table.levels": "שלבים",
    "label.suitable_for_level": "מתאים/ה לשלב",
    "pageTitle.leaders": "מדריכים/ות",
    "moduleTitle.send_test_email": "שלח דואר אלקטרוני לבדיקה",
    "pageTitle.tasks_removed_registration": "הרשמת החניך/כה הוסרה ",
    "label.you_will_be_forced_to_login_again_after_change": "תאלץ להתחבר מחדש לאחר השינוי",
    "table.recent_updates": "עדכונים אחרונים",
    "pageTitle.tasks_activity_signoffs": "אישור מקטע",
    "pageTitle.payments": "תשלומים",
    "global.nights": "לילות",
    "label.blank_any_level": "ריק בכל שלב",
    "button.view_section": "הצג חלק",
    "moduleTitle.select_organization": "בחר/י ארגון",
    "pageTitle.manual_data_import": "ייצוא ידני של מידע",
    "button.upload_files": "העלה קבצים",
    "label.migrated_contact_email": "כתובת מייל שהועברה",
    "label.for_award_unit": "לסניף ",
    "label.aj_template_note": "הערה בתבנית",
    "table.last_log_added": "תיעוד אחרון",
    "button.view_participant": "הערות חניך",
    "label.please_comment_on_the_participants": "נא להגיב על שיפור/ביצוע/מחוייבות החניך/ה",
    "label.consent_already_given_login": "אישור הורים ניתן, אנא התחבר בשם החניך. ",
    "participant.level_start_date": "{value} תאריך התחלה",
    "sidebar.my_region_office": "הסניף המחוזי שלי",
    "states.section_signoff": "מקטע - אישור סופי",
    "moduleTitle.assessor_details": "פרטי מדריך/ה",
    "moduleTitle.adventurous_journey_settings": "הגדרות מסע אתגרי",
    "moduleTitle.note_from_al": "הערה מרכז/ת אות הנוער",
    "button.add_role": "הוסף/הוסיפי תפקיד",
    "table.run": "הפעל/הפעילי",
    "states.change_to_state_warning_missing_assessment": "אזהרה: הערכה לא הוגשה. האם להמשיך?",
    "label.user_app_guide_leader": "מדריך לאפליקציה - מדריך אות הנוער",
    "tabs.section_approval": "אישור מקטע",
    "roles.award_verifier": "מאמת/ת האות",
    "tabs.activity_approval": "אישור פעילות",
    "logs.add_log": "הוסף/ הוסיפי רישום",
    "tabs.award": "אות",
    "notifications.this_role_has_read_only_persmission": "משתמש זה מוגדר לקריאה בלבד",
    "table.no_filtered_results": "אין תוצאות לאחר סינון",
    "button.praise": "הערה",
    "label.prevent_welcome_email_assessor": "אל תשלח מייל קבלה למעריך",
    "label.location_detail": "פרטי מיקום",
    "label.optional": "(אופציונלי)",
    "errors.do_not_match": "לא תואם",
    "label.use_comma_for_multiple_entries": "השתמש בפסיק כמות שמות מרובה",
    "label.operating_authority": "\nסמכויות מפעילות ",
    "label.activity_section": "תחום פעילות",
    "notifications.you_have_been_logged_out": "התנתקת",
    "table.finished": "פעילות הושלמה\n",
    "button.same_as_billing": "זהה לחיוב",
    "table.payment": "תשלום",
    "table.current_level": "שלב נוכחי",
    "button.view_nao": "הערות סניף האות",
    "table.email_confirmation": "אימות דואר אלקטרוני",
    "moduleTitle.shipping_address": "כתובת למשלוח",
    "label.secondary_phone_type": "סוג טלפון שני",
    "notifications.saved": "נשמר",
    "pageTitle.all_participants": "כלל החניכים/ות",
    "label.first_name": "שם פרטי",
    "label.oa_price": "תשלום לארגון המפעיל",
    "table.award_mode": "מצב אות",
    "tabs.api_keys": "Api Keys",
    "award.award_detail": "פרטי האות",
    "tabs.user_management": "ניהול משתמש",
    "tabs.all_events": "כל האירועים",
    "notifications.history_record_has_been_removed": "רישום היסטוריה הוסר",
    "award.no_data": "אין מידע",
    "notifications.preparation_training_has_been_added": "הכשרה ואימוים הוספו",
    "label.message": "הודעה",
    "notifications.participant_info_updated": "מידע החניך עודכן",
    "roles.nao_staff": "צוות המפעיל הארצי (מטה)",
    "tabs.adventurous_journeys": "מסעות אתגר",
    "label.gops": "מפעיל גלבאלי שותף",
    "route.upload": "העלאה",
    "notifications.history_record_has_been_added": " רישום היסטוריה נוסף ",
    "notifications.history_record_has_been_updated": "רישום היסטוריה עודכן",
    "label.no_data": "אין נתונים",
    "button.add_coordinator": "הוספת רכז",
    "label.you_are_already_logged_as": "את/ה כבר מחובר/ת כ-",
    "route.my_national_office": "המטה שלי",
    "tabs.leaders": "מדריכים/ות",
    "label.email_confirmation": "אימות כתובת דואר אלקטרוני",
    "table.registration_date": "תאריך רישום",
    "notifications.role_has_been_removed": "תפקיד הוסר",
    "button.move": "העבר",
    "label.terms_and_conditions": "תנאים והתניות",
    "pageTitle.detail": "פרטים",
    "table.award_unit": "סניף",
    "sidebar.settings": "הגדרות",
    "dashboard.leader_state": "מדריך/רכז - לפי מצב",
    "notifications.award_unit_has_been_approved": "המדריך/ה אושר/ה",
    "states.awaiting_approval": "ממתין לאישור",
    "table.level": "שלב",
    "table.action_requested": "נדרשת פעילות",
    "label.organisation_mode": "מצב ארגוני",
    "label.no_note": "אין הערה",
    "tabs.my_events": "האירועים שלי",
    "notifications.participants_have_been_added": "משתתפים/ות נוספו",
    "tabs.registration_questions": "שאלות הרשמה",
    "button.delete_registration": "מחיקת רישום",
    "notifications.parental_consent_link_has_been_sent": "קישור לאישור הורים נשלח",
    "moduleTitle.select_role_organization": "בחר/י תפקיד וארגון",
    "label.experience": "ניסיון",
    "translationsManagement.modal.title": "ניהולתרגום.תצורה.לעידכון.כותר",
    "table.ic": "IC",
    "table.id": "מס",
    "label.notify_email_explanation": "החניך יקבל הודעה במייל כי הערכה של הפעילות, לא נשלחה והוא יתבקש לתקן את המייל שלו  ויגיש מחדש.",
    "participant.would_you_like_to_remove": "את/ה מעוניין/ת למחוק חשבון זה?",
    "table.fields_included": "שדות כוללים",
    "label.user_guide_web_leader": "מדריך למשתמש/ת - רכז/ת אות הנוער",
    "label.journey_type": "סוג מסע",
    "button.setup": "שמור",
    "tabs.my_national_office": "משרדי המטה שלי",
    "notifications.training_has_been_removed": "אימון הוסר",
    "label.nominated_and_identified_persons": "נציגים מורשים לצפיה בכל המידע אבל לא לבצע שינויי עריכה",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "התחברות הופסקה בשל אי פעילות",
    "states.award_leader_signoff": "אישור סופי - רכז/ת אות הנוער",
    "table.award_signoff_attempts": "נסיונות לאישור שלב",
    "sidebar.regions": "מחוזות",
    "label.activity_deleted_note": "פעילות זו נמחקה. באפשרותך להשיבה מחדש ע\"י לחיצה על הכפתור למטה",
    "table.total": "סה\"כ",
    "errors.a_problem_has_occured_during_processing": "התרחשה תקלה במהלך הפעילות, למידע נוסף",
    "participant.participant_already_has_gold_award": "לחניך יש אות זהב",
    "pageTitle.mro": "הסניף שלי",
    "notifications.authorization_code_has_expired": "קוד אישור פג תוקף",
    "moduleTitle.child_organization_labels": "תג ארגון ילדים",
    "aj.aj_events": "אירועי מסע אתגרי",
    "global.loading": "טוען",
    "label.gnipp": "GNIPP",
    "sidebar.registrations": "רישומים",
    "label.any_string": "כל חוט",
    "contact.change_contact_status": "שינוי סטטוס איש הקשר",
    "tabs.registration": "רישום",
    "label.override_payment_note": "לביטול הוראת התשלום",
    "notifications.section_has_been_signed_off": "מקטע אושר",
    "label.payment_date": "תאריך תשלום",
    "button.approve": "אשר/אשרי",
    "moduleTitle.loggin_in": "מתחבר",
    "label.website": "אתר",
    "label.role": "תפקיד",
    "table.assessor_report": "דיווח מדריך/ה",
    "label.ue_fe": "פעילות משתמש האפליקציה (פעילות החניך באתר לפי תוויות סטטי)",
    "label.please_comment_on_the_participants_effort": "אנא הגב של המאמץ אותו החניכים משקיעים בכדי לעמוד ביעד הפעילות",
    "label.previously_worked_as_assessor": "עבד בעבר כמעריך/מדריך",
    "pageTitle.registrations": "רישומים",
    "parentalConsent.this_form_must_be_completed": "הטופס הזה",
    "button.apply": "שלח",
    "errors.include_at_least_one_number": "יש לכלול לפחות ספרה אחת",
    "label.content_restore": "מרענן",
    "logs.hour": "שעה",
    "parentalConsent.i_have_read_and_understand": "7. קראתי והבנתי את השלבים השונים בתכנית ואת הדרישות לעמידה בת",
    "notifications.award_was_deleted": "אות נמחק",
    "label.journey_category": "קטגוריית מסע",
    "notifications.search_cancelled": "הייתה הפרעה לחיפוש, עליך לחכות שהחיפוש יסתיים.",
    "route.detail": "פרט",
    "route.user_guide": "מדריך למשתמש/ת",
    "moduleTitle.history": "היסטוריה",
    "table.gop_name": "מפעיל גלובאלי",
    "pageTitle.tasks_unassigned_participants": "חניכים/ות לא משויכים/ות",
    "states.inactive": "לא פעיל",
    "pageTitle.search_results": "תוצאות חיפוש",
    "button.proceed_to_login": "המשך/המשיכי להתחברות",
    "pageTitle.assessor_report_reject": "ביקורת דו\"ח מדריך/ה",
    "notifications.contact_has_been_removed": "איש/אשת קשר הוסר/ה",
    "sidebar.operating_authorities": "סמכויות מפעילות",
    "label.no_note_from_participant": "אין אישור מחניך",
    "aj.preparation_and_training": "הכשרה ואימונים",
    "route.user_guide_web_leader": "מדריך למשתמש/ת - רכז/ת אות הנוער",
    "label.position_in_organization": "תפקיד בארגון",
    "errors.emails_dont_match": "כתובות דואר אלקטרוני לא תואמות",
    "route.my_participants": "המשתתפים/ות שלי",
    "pageTitle.customisations": "התאמות",
    "tabs.localization_files": "קבצי התאמה למקום",
    "table.assessor_approval": "אישור מדריך/ה",
    "tabs.related_contacts": "אנשי/נשות קשר רלבנטים",
    "table.aus": "סניפים אות הנוער",
    "table.category": "קטגוריה",
    "errors.file_is_too_large": "קובץ גדול מידי.",
    "label.possible_values": "ערך אפשרי",
    "label.if_your_download_doesnt_start": "במידה וההורדה לא מתחילה אוטומטית נא ללחוץ כאן",
    "route.independent_award_centres": "סניף אות עצמאי",
    "pageTitle.user_guide": "מדריך למשתמש/ת",
    "button.visit": "ביקור",
    "label.hours_first_letter": "לא רלוונטי",
    "pageTitle.my_organization_detail": "הסניף שלי- פרטים",
    "pageTitle.nao_detail": "מפעיל ארצי (מטה) - פרטים",
    "button.change": "שנה/שני",
    "award.aj": "מסע אתגרי",
    "table.award_state": "מדינת האות",
    "pageTitle.tasks_award_signoff": "אישור אות",
    "pageTitle.regions": "מחוזות",
    "notifications.award_has_been_signed_off": "האות אושר",
    "dashboard.award_approved_by": "אותות מאושרים - לפי שלב ב 2016",
    "tabs.new_template": "תבנית חדשה",
    "error.parent_email_must_be_filled": "המייל של ההורה הכרחי",
    "label.organisation_invoicing_name": "שם חשבונית ארגון",
    "pageTitle.related_contacts": "מידע קשור",
    "button.try_again": "סגור/י התראה ונסה/י שוב",
    "label.cannot_be_change_to_another": "שינוי שלב אות לא ניתן לביצוע",
    "notifications.lead_coordinator_has_been_set": "רכז/ת ראשי חדש הוגדר בהצלחה",
    "label.training_name": "שם אימון",
    "moduleTitle.new_contact": "איש/ אשת קשר חדש/ה",
    "translationsManagement.modal.updateTitle": "ניהולתרגום.תצורה.עודכן",
    "moduleTitle.offline_award_units_signoff": "חתימה במצב לא מקוון",
    "notifications.award_level_has_been_changed": "שלב ה\"אות\" שונה",
    "label.subject": "נושא",
    "route.silver_level": "שלב הכסף",
    "label.privacy_notice": "הוראת פרטיות",
    "label.switch_organization": "החלף/ החליפי ארגון",
    "meta.dofe_name": "האות הבינלאומי של הדוכס מאדינברו",
    "route.profile": "פרופיל",
    "roles.super_user": "סופר-משתמש",
    "dashboard.while_you_were_gone": "בזמן שלא היית",
    "label.no_note_from_award_leader": "אין אישור מהסניף",
    "label.middle_name": "שם אמצעי",
    "moduleTitle.new_activity": "פעילות חדשה",
    "organisation.would_you_like_to_remove": "האם תרצה להסיר את הארגון הזה?",
    "label.state_province": "מדינה/ מחוז",
    "moduleTitle.your_home_address": "כתובת בבית",
    "tabs.sign_offs": "אישורים סופיים",
    "moduleTitle.logs": "רישומים",
    "button.view_more": "ראה/י עוד",
    "label.profile": "פרופיל",
    "label.title": "תואר",
    "tabs.award_signoff": "אישור סופי לאות",
    "label.post_code": "מיקוד",
    "states.ceremony_certificate": "טקס ותעודה",
    "label.code": "קוד",
    "parentalConsent.i_consent_to_the_provision_of_any": "3. אני מסכים לספק את כל המידע האישי שסיפקתי (כולל נתוני משתתף) לסניף ולמטה 'אות הנוער'. אני מסכים לכך שמידע זה יטופל בהתאם להוראות מדיניות הפרטיות של מפעילי 'אות הנוער' (כפי שיעודכן מעת לעת),בהתאם לדרישות החוק, וכל חוק פרטיות, תקנים, הנחיות או הוראות אחרים המחייבים את מפעילי 'אות הנוער' במסגרת חקיקת הפרטיות.",
    "label.user_guide_web_participant": "מדריך למשתמש/ת לאתר - חניכים",
    "label.award_unit_type": "סוג סניף",
    "states.complete": "הושלם",
    "table.participant_state": "מדינת חניך/ה ",
    "pageTitle.my_organization_payment": "הסניף שלי- תשלום",
    "table.approved": "מאושר",
    "pageTitle.my_organization_contacts": "הארגון שלי - אנשי קשר",
    "warning.award_marked_as_paid_registration": "אזהרה: ישנה לפחות הרשמה אחת לאות המסומנת כמשולמת. אנא פנה להנחיות החזר כספי לפני אישור המחיקה של החניך.",
    "states.change_to_state": "שנה/י ל:  <strong>{state}</strong>",
    "label.integer": "מספר שלם",
    "notifications.translationUpdateInterrupted": "עידכונים.עידכוןהתרגוםהופרע",
    "notifications.password_has_been_changed": "סיסמה שונתה בהצלחה",
    "button.invite_assessor": "הזמן מדריך/ה",
    "label.other_activity": "פעילות אחרת",
    "notifications.parental_consent_has_been_sent": "נשלח אישור הורים",
    "button.revise": "עריכה",
    "errors.end_date_must_be_after_start_date": "תאריך סיום יגיע לאחר תאריך התחלה",
    "label.award_leader_signoff_date": "תאריך חתימה של רכז",
    "parentalConsent.i_understand_every_participant_must": "8. הבנתי של חניך באות הנוער חייב להשתתף בפעילות דרך הסניף ביישוב ושלמדריך /לרכז סניף הסמכות לאשר את הפעילות למעבר שלב וקבלת סיכת האות",
    "moduleTitle.policies": "נהלים",
    "pageTitle.tasks_aj": "מסע אתגרי",
    "global.day": "יום",
    "moduleTitle.coordinator": "רכז/ת",
    "label.region": "מחוז",
    "button.add_history_record": "הוסף היסטוריית גלישה",
    "moduleTitle.adventurous_journey_template_settings": "הגדרות תבניות מסע אתגרי",
    "notifications.personal_details_have_been_updated": "פרטים אישיים עודכנו",
    "sidebar.ics": "ICs",
    "table.independent_award_centre": "סניף",
    "label.undelivered_mail_reason": "סיבה לכשל השליחת המייל",
    "table.utc_date_time": "אזור זמן",
    "moduleTitle.emails": "מיילים",
    "label.backoffice": "label.ניהול",
    "moduleTitle.parent_consent": "הסכמת הורים/ אפוטרופוס",
    "label.photo_consent_given": "משתתף אישר כי נוכל להשתמש בתמונתו לצרכי פרסום",
    "moduleTitle.authorising_contact": "איש קשר לאישור",
    "label.assessment_with_role": "מעריך",
    "dashboard.type_of_awards": "שיוך המחלקה",
    "moduleTitle.payment": "תשלום",
    "states.in_progress": "בתהליך",
    "logs.no_logs": "אין רישומים",
    "sidebar.my_office": "המשרד שלי",
    "label.assessor_report": "דיווח מדריך/ה",
    "notifications.rp_has_been_signed_off": "פרויקט קהילתי עבר אישור לאחר ביצוע",
    "tabs.labels": "תגיות",
    "sidebar.payments": "תשלומים",
    "meta.profile_questions": "שאלות פרופיל",
    "label.fax": "פקס",
    "label.email_help_custom_link": "לינק מותאם אישית, אם מופעל.",
    "label.last_name": "שם משפחה",
    "organisation.manage_gop": "נהל מפעיל גלובאלי",
    "table.parental_consent": "הסכמת הורים",
    "dashboard.participant_by_level": "משתתפים - לפי שלב",
    "tabs.award_leaders": "מדריכים/ות",
    "label.i_confirm_that_ive_witnessed": "אני מאשר כי הייתי עד לרישום המשתתפים בפנקס עבור הפעילויות מטה",
    "table.lead_coordinator": "רכז מוביל",
    "states.deleted": "מחיקה",
    "label.no_answers": "אין מענה",
    "button.add": "הוספה",
    "label.exchequer_number": "מספר מטבע ההמרה",
    "label.waiting": "ממתין",
    "label.email_help_person_full_name": "שם מלא.",
    "tasks.return_registration": "בקר/י רישום",
    "notifications.state_aj_preparation_training_has_been_changed": "המצב של ההכנה ומסע ההכנה שונה בהצלחה.",
    "label.parent_approval": "אישור הורים",
    "table.assessor_approve": "מדריך/ה מאשר/ת",
    "errors.some_fields_requires_your_attention": "את/ה מתבקש/ת לשים לב לשדות מסוימים",
    "aj.qualifying_journey": "מסע מעבר שלב",
    "route.awards": "אותות",
    "table.registration": "רישום",
    "pageTitle.assessors": "מדריכים/ות",
    "notifications.award_has_been_updated": "האות",
    "errors.must_be_one_of": "חייב להיות אחד מ: {enums}",
    "pageTitle.logs": "התחברויות",
    "notifications.notifications.invitation_has_been_sent": "הזמנה נשלחה",
    "route.national_offices": "מטות",
    "notifications.training_has_been_updated": "אימון עודכן",
    "label.parent_last_name": "שם משפחה של הורה/ אפוטרופוס",
    "table.leaders": "מדריכים/ות",
    "states.award_level_complete": "שלב הושלם",
    "button.reset": "מחיקה",
    "sidebar.my_award_unit": "הסניף שלי",
    "pageTitle.all_aj_events": "כלל אירועי המסע האתגרי",
    "label.activity": "פעילות",
    "moduleTitle.are_you_sure": "את/ה בטוח/ה?",
    "route.gold_level": "שלב הזהב",
    "table.evidence": "עדות",
    "label.delivery_confirmed": "משלוח אושר",
    "parentalConsent.as_the_parent": "כהורה/ אפוטרופוס אני מאשר ל'אות הנוער' לעשות שימוש בתמונות לצרכים שיווקיים",
    "label.awardMode.offline": "לא מקון",
    "tasks.approve_registration": "אישור הרשמה",
    "note.change_the_email_will_change": "הערה: שינוי כתובת הדואר האלקטרוני תביא לשינוי כתובת דואר אלקטרוני של איש/ אשת קשר",
    "notifications.participant_has_been_approved": "משתתף/ת אושר/ה",
    "label.reached_activity_limit": "הגעת לכמות הפעילויות המקסימאלית. חניכים יכולים לקיים לכול היותר  3 פעילויות בכל תחום ",
    "label.facebook": "פייסבוק",
    "notifications.label_has_been_removed": "התגית עודכה.",
    "label.action_required": "דרושה פעולה",
    "notifications.preparation_training_has_been_removed": "הכשרה ואימונים הוסרו",
    "pageTitle.settings": "הגדרות",
    "participant.level_registration_date": "{value} תאריך רישום",
    "notifications.question_has_been_removed": "שאלה הוסרה",
    "label.email_help_award_leader_full_name": "שם מלא של מדריך/רכז.",
    "sidebar.leaders": "מדריכים/ות",
    "notifications.participants_have_been_transferred": "חניכים/ות הועברו",
    "tabs.assessors": "מדריכים/ות",
    "sidebar.dashboard": "תצוגת נתונים ראשית",
    "pageTitle.independent_award_centers": "סניפים עצמאיים",
    "label.search": "חפש",
    "moduleTitle.office_labels": "תגיות משרד",
    "label.note_from_participant": "הערה למשתתף/ת",
    "errors.required_field": "שדה נדרש",
    "tasks.approve_task": "אשר/י משימה",
    "logs.edit_log": "ערוך/ערכי רישום",
    "table.state": "מדינה",
    "moduleTitle.level_summary": "סיכום שלב",
    "moduleTitle.guides": "הנחיות",
    "modal.close": "סגור/סגרי",
    "label.parent_first_name": "שם פרטי של הורה/ אפוטרופוס",
    "parentalConsent.i_understand_that_the_participant": "1. אני מודע לכך שהמשתתף אינו יכול להשתתף ב\"אות\" עד להשלמת טופס זה (כולל הסכמת הורה / אפוטרופוס) ושהפעילות תכוסה בביטוח רק לאחר תשלום דמי הרישום השנתיים למרכז הפעילות.",
    "tabs.award_units": "סניפי אות הנוער",
    "table.hours": "שעות",
    "label.type": "סוג",
    "notifications.adventurous_journey_has_been_removed": "מסע אתגרי הוסר",
    "label.aj_is_not_approved_yet": "מסע אתגרי עדיין לא אושר ",
    "roles.authorizing_contact": "איש/ אשת קשר לאימות",
    "table.date_submitted_to_office_signoff": "תאריך הגשת האות לאישור המטה",
    "notifications.section_has_been_returned": "מקטע עבר בקרה",
    "table.created_by": "נוצר על ידי",
    "route.user_guide_web_participant": "מדריך למשתמש/ת לאתר - חניכים",
    "route.templates": "תבניות",
    "states.awaiting_sign_off": "אישור סופי של רכז/ת אות הנוער",
    "table.phone": "טלפון",
    "label.parental_consent": "אישור הורים",
    "label.org_contact_will_be_deleted": "אתה מסיר את התפקיד האחרון של האדם הזה בארגון. האם תרצה לשמור את הפרטים האישיים של האדם או להסיר לחלוטין את הפרטים מהארגון?",
    "route.bronze_level": "שלב הארד",
    "label.invoice_currency": "מטבע החשבונית",
    "button.new_label": "תג חדש",
    "error.server_cannot_be_reached_at_the_moment": "השרת לא זמין ברגע זה. אנא נסה שוב מאוחר יותר. במידה ותקלה חוזרת אנא פנה לצוות המטה.",
    "notifications.contact_has_been_created": "איש/אשת קשר נוצר/ה",
    "pageTitle.profile_questions": "שאלות פרופיל",
    "table.observation_files": "תיקיות תצפית",
    "table.participants": "משתתפים/ות",
    "tasks.no_evidence": "לא סופק תיעוד",
    "button.edit": "ערוך/ערכי",
    "moduleTitle.leader": "מדריך/ה",
    "notifications.new_template_has_been_updated": "תבנית חדשה עודכנה",
    "table.name": "שם",
    "label.no_results": "אין תוצאות",
    "moduleTitle.documents": "מסמכים",
    "button.invite": "להזמין",
    "label.goal": "יעד",
    "pageTitle.nao_award_units": "מפעיל ארצי (מטה)- סניפי אות",
    "label.award_delete_participant_id": "מספר מזהה של חניך",
    "errors.at_least_num_characters": "לפחות {length} תווים",
    "label.email_help_note": "הערה מותאמת אישית, אם מופעל.",
    "label.person_status.activating": "label.מצב נוכחי.משימות",
    "moduleTitle.remove_role": "להסיר כלל?",
    "label.total": "סה\"כ",
    "label.delete_participant_award_info": "אתה עומד למחוק שלב באות עבור חניך. פעולה זו הינה בלתי הפיכה ולכן ישנם מספר חוקים \n1) לחניך חייב להיות שלב פעיל נוסף באות הנוער\n2) פעילות עיקרית תמחק במקרה היא נדרשת לשלב אותו אתה עומד למחוק\n3) במידה ויש שני שלבים נוספים פעילים לאחר מחיקה, אז פעילות עיקרית תקבע לנמוך מביניהם רק במידה והשלב נמצא בפעילות ולא - דרוש אישור/ הושלם /טקס",
    "route.leaders": "מדריכים/ות",
    "table.start_date": "תאריך התחלה",
    "moduleTitle.coordinators": "רכזים",
    "button.create": "צור/צרי",
    "tabs.awards": "אותות",
    "parentalConsent.form_has_been_sent": "הסכמת הורים נשלחה",
    "states.journey_approval": "אישור מסע",
    "pageTitle.reports": "דיווחים",
    "table.journey_type": "סוג מסע",
    "label.yes": "כן",
    "pageTitle.assessor_report": "דו\"ח מדריך/ה",
    "label.organization": "ארגון",
    "notifications.award_leader_has_been_updated": "רכז/ת עודכן/ה",
    "moduleTitle.edit_role": "עריכת תפקיד",
    "table.journey_activity": "פעילות מסע",
    "label.location": "מיקום",
    "label.update_translations_error_item": "עדכון תרגום נכשל עבור: {language} קוד: {localeCode},  פרויקט: {projectCode} עקב",
    "pageTitle.adventurous_journeys": "מסעות אתגריים",
    "global.assessor": "מדריך/ה",
    "moduleTitle.profile_questions": "שאלות פרופיל",
    "activity.cannot_edit_activity_if_award_in_state": "לא ניתן לערוך פעילות את האות ב{state} מצב",
    "moduleTitle.assessor_detail": "פרטי מדריך/ה",
    "parentalConsent.i_understand_that_upon_acceptance_into": "10. אני מבין/ה כי עם הצטרפות ל'אות הנוער', המשתתף/ת יקבל/תקבל גישה אל אפליקציית מערכת המידע  (אות\"ה). המשתתף יקרא ויכיר את הדרישות הפעילות ביחס לכל שלב בפעילות. אני מבין שלרשות ארגון אות הנוער השיקול  לקבוע האם התקיימו דרישות התוכנית, וכן לאישור קבלת אותות הארד, כסף או זהב. ",
    "notifications.award_has_been_returned": "נערכה בקרת שלב",
    "label.code_of_conduct": "קוד התנהגות",
    "button.new_contact": "איש/אשת קשר חדש/ה",
    "tabs.payments": "תשלומים",
    "roles.naa_oa_staff": "צוות מטה",
    "label.switch_organisation_hint": "ניתן לפתוח חלון זה בכל ולבחור ב'בשינוי ארגון' בצד הימין עליון של התפריט",
    "label.expiration_date": "תאריך תפוגה",
    "tabs.participants": "משתתפים/ות",
    "table.practice": "אימון",
    "notifications.one_activity_has_to_remain": "יש להשאיר לפחות פעילות אחת בתחום ",
    "label.qualifications": "כישורים",
    "states.organization_approval": "אישור הארגון",
    "errors.must_be_an_integer": "חייב להיות מספר שלם",
    "participant.send_confirmation_email_again_question": "שליחת מייל אישור בשנית?",
    "button.dismiss": "אישור",
    "table.advice": "עצה",
    "label.years_of_working_experience": "שנות ניסיון עבודה ",
    "notifications.search_failed": "הייתה שגיאה בחיפוש. אנא נסה/י שוב מאוחר יותר",
    "notifications.changes_have_been_saved": "השינויים נשמרו",
    "moduleTitle.resend_parental_consent_link": "שליחה מחדש של חוזר הורים?",
    "label.activity_type": "סוג פעילות",
    "label.change_award": "לשינוי שלב ב\"אות\"",
    "label.email": "דואר אלקטרוני",
    "button.remove": "הסר/י",
    "button.download": "הורדה",
    "label.vat_treatment": "טיפול מעמ",
    "pageTitle.aj_template_new": "מסע אתגרי חדש - תבנית",
    "table.per_page": "לעמוד",
    "notifications.translations_has_been_updated": "עדכונים.תרגום_עודכן_בהצלחה",
    "notification.award_mode_has_been_updated": "מצב האות עודכן בהצלחה",
    "tasks.revise_item": "בקר/י פריט",
    "button.resend_parental_consent": "שלח/י מחדש אישור הורים",
    "table.weeks_completed_required": "שבועות הושלמו/ נדרשים",
    "label.last_modified": "שונה לאחרונה",
    "table.major": "תחום ראשי",
    "label.vat_number": "מספר מעמ",
    "errors.passwords_dont_match": "סיסמאות לא תואמות",
    "table.country": "מדינה",
    "sidebar.guides_and_policies": "הנחיות ונהלים",
    "notifications.question_has_been_updated": "שאלה עודכנה",
    "table.participant_name": "שם חניך",
    "label.registration_approval_date": "תאריך הרשמה מאושר",
    "notifications.auth_code_is_no_longer_valid": "קוד הרשאה לא בתוקף",
    "errors.must_be_no_more_than": "יכול להכיל לא יותר מ {max} תווים",
    "notifications.event_has_been_rejected": "אירוע עבר בקרה",
    "tabs.customizations": "התאמה אישית",
    "label.name_organization": "שם",
    "button.add_log": "הוספת רישום",
    "moduleTitle.invite_assessor": "הזמן/י מדריכ/ה",
    "label.resend_confirmation_email": "שלח מחדש את אישור מייל",
    "text.all_participants_will_be_transfered": "כל החניכים/ות יועברו לרכז/ת חדש/ה",
    "label.repeat_email": "נא לחזור על כתובת הדואר האלקטרוני",
    "errors.email_or_phone_required": "מייל או טלפון נייד נדרש",
    "notifications.role_has_been_updated": "כלל עודכן",
    "roles.if_staff_stat_user": "משתמש סטטסטי",
    "participant.delete_account": "מחיקת חשבון",
    "moduleTitle.would_you_like_to_remove_this_log": "למחוק את הרישום הזה?",
    "sidebar.sgops": "SGOPs",
    "label.prepare_new_email": "נסח הודעה חדשה",
    "table.journey_category": "קטגוריית מסע",
    "sidebar.manual_data_import": "יצא מידע ידני",
    "label.created_after_date": "נוצר לאחר",
    "route.my_organization": "הארגון שלי",
    "button.show_list": "הראה רשימה",
    "label.leaders": "מדריכים/ות",
    "notifications.log_has_been_modified": "רישום עודכן",
    "button.upload_file": "העלאת קובץ",
    "moduleTitle.which_section_do_you_want_to": "איזה מקטע ברצונך להחזיר ל'בתהליך'? ",
    "tabs.bronze_level": "שלב הארד",
    "notifications.participants_have_been_saved": "משתתפים/ות נשמרו",
    "pageTitle.aj_template_detail": "מסע אתגרי",
    "label.parent_email": "כתובת דואר אלקטרוני של הורה&#39;s/ אפוטרופוס&#39;s",
    "map.appr_location": "כתובת ידועה",
    "notifications.log_has_been_removed": "רישום הוסר",
    "notifications.label_has_been_assigned": "תגית הוצמדה.",
    "pageTitle.tasks_undelivered_emails": "מיילים שנכשלו",
    "button.stay": "להשאר",
    "table.previous_level": "שלב קודם",
    "label.award_start_date": "תאריך תחילת השלב",
    "assessor_report.returned_to_participant": "מוחזר למשתתף/ת",
    "pageTitle.tasks_assessors_registration": "הרשמת מעריך/מדריך",
    "aj.cannot_modify_award": "אינך יכול לשנות את שלב האות אם המשתתפ/ת לא משויך/ת למדריך/ה",
    "moduleTitle.lost_internet_connection": "נראה כי אבדה הקליטה לרשת ",
    "states.ceremony": "טקס",
    "participant.reactivate_account": "הפעל/י מחדש חשבון",
    "label.birthdate": "תאריך לידה",
    "pageTitle.assessment_send_successfully": "הערכה נשלחה בהצלחה ",
    "states.assessor_approval": "אישור מדריך/ה",
    "award.change_award_level": "שינוי שלב ה\"אות\"",
    "label.url_no_longer_valid": "כתובת האינטרנט אינה בתוקף",
    "button.update": "עדכון",
    "label.secondary_email": "כתובת מייל שניה",
    "button.role_edit": "עריכה",
    "table.award_leader": "רכז/ת",
    "label.level": "שלב",
    "tasks.evidence": "עדות",
    "notifications.participant_is_already_in_list": "החניכ/ה כבר נמצא/ת ברשימה",
    "button.clear": "הסר/הסירי",
    "label.allow_log_after_25_yoa": "אפשר להזין דיווח מתקופה של 25 שנה",
    "states.setup": "הגדרות",
    "table.activity": "פעילות",
    "label.copy_to_clipboard": "{text} הועתק ללוח.",
    "route.award_units": "סניפי אות הנוער",
    "button.upload_photo": "העלאת תמונה",
    "table.hours_completed_required": "שעות הושלמו/ נדרשות",
    "table.first_name": "שם פרטי",
    "notifications.adventurous_journey_has_been_returned": "מסע אתגרי עבר בקרה",
    "pageTitle.national_offices": "מטה",
    "notifications.you_have_been_logged_in": "התחברת",
    "logs.offline": "אופליין",
    "moduleTitle.add_role": "הוספת כלל",
    "label.user_app_guide_participant": "מדריך למשתמש/ת לאפליקצית חניכים/ות",
    "notifications.file_has_been_removed": "המסמך הוסר",
    "label.send_message": "שלח הודעה",
    "button.select": "בחר/י",
    "label.reason_of_deletion": "סיבת המחיקה",
    "label.user_guide": "מדריך למשתמש/ת",
    "pageTitle.nao_participants": "מפעיל ארצי(מטה) - חניכים",
    "tabs.sub_operating_partners": "מפעילי משנה שותפים",
    "table.uploaded_by": "הועלה על ידי",
    "tasks.approve_item": "אשר/י פריט",
    "tasks.restore_participant_registration": "לשחזר הרשמת חניך/כה?",
    "label.awardMode.hybrid": "הברידי",
    "table.first_activity_started": "פעילות ראשונה החלה",
    "moduleTitle.dates": "תאריכים",
    "table.no_results": "אין תוצאות",
    "states.registration_approval": "אישור רישום",
    "table.breakdown_of_hours": "חלקיות השעה",
    "pageTitle.tasks_registration": "רישום חניכים",
    "button.create_new": "צור/צרי חדש",
    "sidebar.todolist": "רשימת משימות",
    "label.active_participants": "משתתפ/ת פעילה",
    "moduleTitle.postalAddress": "moduleTitle.כתובת דואר",
    "tasks.return_task": "בקר/י משימה",
    "organisation.change_organisation_state": "שנה/י מצב הארגון",
    "moduleTitle.roles": "תפקידים",
    "label.no_config_key_available": "שילוב מקשים לא זמין בחלון זה",
    "placeholder.selectLanguage": "placeholder.בחר שפה",
    "states.office_signoff": "משרד - אישור סופי",
    "notifications.translations_has_been_updated.failure": "עדכונים.תרגום_עודכן_נכשל",
    "logs.minute": "דקה",
    "label.last_activity": "פעילות אחרונה",
    "sidebar.user_guide": "מדריך למשתמש/ת",
    "label.trained_award_leader": "רכז/ת אות הנוער מוסמך",
    "table.progress": "התקדמות",
    "table.suboperating_authorities": "רשויות מפעילות משנה",
    "activity.cannot_edit_activity_offline": "משתתף זה הוגדר כלא זמין.<br><br> אינך יכול לערוך; פעילות, מסעות, או פרויקט יזמות במידה ומצב הפעילות לא זמין חלקית.",
    "label.user_does_not_have_permissions": "למשתמש/ת <strong>{user}</strong> אין הרשאה לראות תוכן זה",
    "notifications.assessor_has_been_approved": "המדריכ/ה אושר",
    "route.activity_approval": "אישור פעילות",
    "moduleTitle.role": "כלל",
    "button.run": "הפעל",
    "label.to": "אל",
    "notifications.file_has_been_updated": "המסמך עודכן",
    "moduleTitle.edit_coordinator": "עורך רכז/ת",
    "notifications.authorization_code_is_no_longer_valid": "קוד אימות לא בתוקף",
    "button.reject": "עריכה",
    "label.label.participant_status": "סטטוס משתתף/ת",
    "award.gold_level": "שלב הזהב",
    "sidebar.variables": "משתנים",
    "parentalConsent.checkbox_copy": "אני מאשר שאני הורה/ אפוטרופוס של {firstName} {lastName}. \nאני מאשר לו/לה להשתתף בפעילות 'האות הבינלאומי לנוער ולצעירים - ישראל' בהדרכתו/ה של {organisationName}. קראתי, הבנתי והסכמתי עם הדרישות ותנאי ההשתפות ב'אות הנוער' כפי שתוארו לעיל ובאתר 'אות הנוער'.",
    "button.go_to_dashboard": "עבור/עברי ללוח",
    "button.add_option": "להוספת אפשרות",
    "label.is_completed": "הושלם",
    "pageTitle.award_units": "סניפי אות הנוער",
    "states.completed": "הושלם",
    "button.adventurous_journey_template_settings": "הגדרות תבניות מסע אתגרי",
    "label.system_rights": "זכויות מערכת",
    "label.assessor_assesstment_award_start_date": "label.תאריך תחילת הערכת רכז",
    "label.update_translation_question": "תרגומים עבור כלל השפות הקיימות בפרויקטיים הנבחרים יעודכנו.",
    "button.login": "התחברות",
    "label.name_of_the_unit": "שם סניף",
    "button.send": "שלח",
    "award.ajs": "מסעות אתגריים",
    "meta.payments_expired": "תשלומים שבוצעו",
    "label.age": "גיל",
    "notifications.payment_info_updated": "אמצעי תשלום עודכן",
    "table.is_completed": "הושלם",
    "table.invited_by": "הוזמן על ידי",
    "route.files": "קבצים",
    "route.assessors": "מדריכים/ות",
    "info.aj_supervisor_is_mandatory": "בעבור מסע אימון את הערכה יקבל המדריך, ועבור המסע המעריך יקבל  את הערכה.",
    "pageTitle.my_participants": "החניכים/ות שלי",
    "label.change_leader_status": "שינוי מצב מדריכים/ות",
    "moduleTitle.parent_consent_form": "טופס הסכמת הורים/ אפוטרופוס",
    "notifications.authorization_contact_has_been_set": "הוגדר איש/אשת קשר לאישרור",
    "button.close": "סגור/סגרי",
    "label.independent_country": "מדינה עצמאית",
    "notifications.aj_preparation_training_has_been_returned": "הכנות והכשרה למסע האתגרי עברו בקרה ",
    "route.history_log": "היסטוריית רישומים",
    "participant.account_settings": "הגדרות חשבון",
    "label.bulk_action_error_item": "{globalId} {firstName} {lastName} {email} נכשל כי",
    "label.orb_account": "חשבון אות\"ה",
    "notifications.file_url_is_not_specified_in_configuration": "כתובת url של הקובץ לא מצוינת בקונפיגורציה",
    "notifications.award_unit_has_been_removed": "הסניף/יחידת האות הוסרה",
    "table.parent": "הורה",
    "label.mode_of_transport": "אמצעי תחבורה",
    "label.parental_consent_email_info": "אל תשכח לבדוק את דוא\"ל ההורה ולשלוח את ההסכמה ידנית.",
    "label.current_award": "שלב נוכחי",
    "table.action": "פעולה",
    "pageTitle.suboperating_authorities": "תפעול משנה",
    "notifications.award_leader_has_been_assigned": "המדריך/כה שוייך/ה",
    "tabs.sign_offs_locally": "אישורים סופיים מקומי",
    "Activity log has been restored": "רישום התראה שוחזר",
    "sidebar.naos": "מפעילים ארציים (מטות)",
    "tabs.aj_templates": "מסע אתגרי - תבניות",
    "notifications.logging_out": "מתנתק מהמערכת...",
    "label.update_label": "עדכן תגית",
    "button.organisation_settings": "מצב הארגון",
    "tabs.independent_award_centers": "סניפים עצמאיים",
    "label.current": "נוכחי",
    "table.location": "מיקום",
    "button.search": "חיפוש",
    "notifications.aj_preparation_training_has_been_approved": "הכשרה והכנות למסע אתגרי אושרו",
    "route.participants": "משתתפים/ות",
    "label.other_location_information": "מיקום - מידע נוסף",
    "label.number_of_records": "מספר רשומות",
    "translationsManagement.infoLabel": "ניהולתרגום.תצורה.מידע",
    "parentalConsent.i_consent_to_pay_all": "5. ידוע לי כי אשא בהוצאות רפואיות אם יגרם נזק כתוצאה מפציעה, תאונה, מחלה או אובדן בזמן השתתפות בפעילות במסע או בכל פעילות הקשורה לאות הנוער",
    "label.nationality": "לאום",
    "states.approval": "אישור",
    "notifications.something_went_wrong": "משהו השתבש",
    "aj.practice": "אימון",
    "label.addressLine2": "כתובת - שורה שניה",
    "label.please_leave_a_note": "נא להשאיר הודעה",
    "placeholder.select": "בחר/י",
    "label.observations": "תצפיות",
    "label.aim": "יעד",
    "label.addressLine1": "כתובת - שורה ראשונה",
    "roles.aj_instructor": "מדריך מסע",
    "meta.payments_waiting": "תשלומים בהמתנה",
    "label.award_to_delete": "מחק שלב אות",
    "label.category": "קטגוריה",
    "roles.instructor": "מנחה",
    "moduleTitle.remove_customization_and_reset": "הסרת הגדרות ואיפוס ערך?",
    "notifications.participant_registration_has_been_restored": "הרשמת החניך/כה שוחזרה",
    "organisation.change_award_unit_mode": "שנה מצב ארגוני",
    "table.organization_type": "סוג ארגון",
    "notifications.participant_has_been_deleted": "חניך/ה נמחק/ה",
    "label.language_settings": "הגדרות שפה",
    "notifications.event_has_been_approved": "אירוע אושר",
    "label.password": "סיסמה",
    "label.text": "טקסט",
    "table.observations": "תצפיות",
    "notifications.participant_has_been_created": "חניך/ה נוצר/ה",
    "table.note_for_al": "הערה למדריך/ה - רכז/ת",
    "label.payment_confirmed": "תשלום אושר",
    "label.previous_completed_award_level": "שלב קודם (לא אות\"ה)",
    "pageTitle.new_aj_event": "אירוע חדש - מסע אתגרי",
    "label.backend": "label.קוד",
    "label.relationship_to_participant": "קשר לחניך",
    "award.physical_recreation": "פעילות ספורטיבית",
    "contact.collect_emails": "איסוף כתובות מייל למשלוח",
    "moduleTitle.assessor_report_reject": "דוח מדריך/ה נדחה",
    "label.supervisor_report": "דיווח מפקח/ת",
    "table.role": "תפקיד",
    "route.user_guide_web_nao": "מדריך למשתמש/ת - מפ\"א (מטה)",
    "label.page_not_found": "404 - עמוד לא נמצא",
    "table.labels": "תגיות",
    "notifications.file_has_been_uploaded": "המסמך הועלה",
    "moduleTitle.address": "כתובת",
    "moduleTitle.lead_coordinator": "רכז/ת מוביל",
    "pageTitle.login": "כניסה",
    "label.frontoffice": "label.תצוגה",
    "participant.would_you_like_to_remove_registration": "האם אתה מעוניין למחוק את ההרשמה?",
    "notifications.rp_has_been_setup": "פרויקט קהילתי הוגדר",
    "moduleTitle.award_unit": "סניף",
    "button.remove_file": "הסר קובץ",
    "moduleTitle.billing_address": "כתובת למשלוח חשבונית",
    "pageTitle.my_aj_events": "אירועי המסע האתגרי שלי",
    "route.tasks": "משימות",
    "button.confirm": "אשר/י",
    "label.national_award_authority": "סמכות 'אות הנוער' ארצית",
    "label.independent_award_centre": "סניף עצמאי",
    "award.generate_award_report": "ליצירת דיווח",
    "route.my_region_office_customization": "המשרד המחוזי שלי - התאמות",
    "label.email_help_aj_category": "סוג מסע.",
    "label.your_report_has_been_rejected": "ביצעת דחייה של המשימה",
    "notifications.password_change_request_has_been_sent": "בקשה לשינוי סיסמה נשלחה",
    "tabs.detail": "פירוט",
    "participant.change_participant_status": "שינוי סטטוס חניך/ה",
    "table.key": "תא",
    "label.find_address": "אתר כתובת",
    "notifications.assessor_has_been_rejected": "מדריך/ה התקבל/ה",
    "label.transfer_participants": "העברת חניכים/ות",
    "button.continue_to_payment_gateway": "להמשך לדף תשלום",
    "notifications.participant_registration_has_been_removed": "הרשמת המשתתף הוסרה",
    "moduleTitle.page_not_found": "404 - עמוד לא נמצא",
    "route.adventurous_journeys": "מסע אתגרי",
    "states.registration_assessment": "הערכת רישום",
    "heading.change_award_unit_mode": "שנה הגדרת הסניף",
    "label.user_guide_web_nao": "מדריך למשתמש/ת לאתר - מפעיל ארצי (מטה)",
    "tabs.silver_level": "שלב הכסף",
    "table.paid_by": "שולם באמצעות",
    "label.your_report_has_been_successfully_sent": "הדיווח שלך נשלח בהצלחה",
    "sidebar.my_organization": "הארגון שלי",
    "pageTitle.participants": "משתתפים/ות",
    "notifications.preparation_training_has_been_updated": "הכשרות ואימונים עודכנו",
    "moduleTitle.server_is_unreachable": "השרת לא זמין",
    "label.last_activity_date": "תאריך פעילות אחרונה",
    "award.bronze_level": "שלב הארד",
    "moduleTitle.award_units": "יחידות האות",
    "table.completed": "הושלם/ה",
    "moduleTitle.revise_message": "תיקון ההודעה",
    "table.lastUsed": "שימוש אחרון",
    "award.bronze_to_gold_level": "שלב הארד לשלב הזהב",
    "button.change_password": "שנה/י סיסמה",
    "label.nao_price": "תשלום לארגון הארצי",
    "label.payment_state": "מצב תשלום",
    "label.wwc_expired": "WWC תפוגה",
    "label.award_office_signoff_date": "תאריך חתימה של המטה",
    "label.award_unit": "סניף",
    "award.gold_level_short": "זהב",
    "moduleTitle.other_info": "מידע נוסף",
    "table.note": "הערה",
    "label.search_by_email_first_or_last": "חיפוש לפי כתובת דוא\"ל, שם פרטי או שם משפחה",
    "tabs.history": "היסטוריה",
    "notifications.label_has_been_created": "תגית חדשה נוצרה.",
    "tabs.unassigned_participants": "חניכים/ות לא משויכים/ות",
    "table.main_award_leader": "רכז/ת",
    "parentalConsent.i_as_the_parent": "אני מבינן/ה כי פעולות מסוימות נחשבות כספורטיביות ו/או אתגריות נחשבות לבעלות סיכון גבוה, והם אינם מכוסות לגמרי על ביטוח הארגון, אני מבין כי פעילות מסוג נדרשת כיסוי נוסף באחריות המשתתף.",
    "label.state": "מצב",
    "notifications.award_leader_has_been_removed": "רכז/ת הוסר/ה",
    "tabs.organization_detail": "פרטי ארגון",
    "table.operating_authorities": "רשויות מפעילות",
    "label.available_labels": "תגיות אפשריות",
    "modal.select": "בחר/י",
    "tabs.expired_payments": "תשלומים שהסתיימו",
    "moduleTitle.note_for_al": "הערה למדריך/ה - רכז/ת",
    "moduleTitle.confirm": "אשר/י",
    "notification.new_activity_added": "פעילות חדשה נוספה",
    "notifications.award_leader_has_been_moved": "המדריך/כה  הועבר/ה",
    "label.award_mode": "מצב אות",
    "label.phone": "טלפון",
    "notifications.organization_has_been_updated": "הארגון עודכן",
    "moduleTitle.assessor": "מדריך/ה",
    "label.bulk_action_confirmation": "אשר שינוי לכולם",
    "table.parent_approval": "אישור הורים",
    "label.date_of_delivery": "תאריך משלוח",
    "sidebar.assessors": "מדריכים/ות",
    "label.journey_activity": "פעילות מסע",
    "award.inactive_award": "אות לא פעיל",
    "label.end_date": "תאריך סיום",
    "label.orb_testing": "בדיקת אות\"ה",
    "label.no_activities": "אין פעילויות",
    "moduleTitle.please_confirm": "יש לאשר",
    "button.login_with_another_account": "התחבר/י לחשבון אחר",
    "tasks.reject_registration": "בקר/י רישום",
    "label.submitted_after_date": "הוגש לאחר",
    "label.update_translations_successful": "{count} פריטים שונו בהצלחה.",
    "button.assign_leader": "מנה/י מדריך/ה",
    "table.already_running": "כבר פועל",
    "label.no": "לא",
    "label.count_items_selected": "{count} פריטים נבחרו",
    "label.secondary_phone_number": "מספר טלפון שני",
    "label.my_experience": "החוויה שלי",
    "notifications.adventurous_journey_has_been_approved": "מסע אתגרי אושר",
    "pageTitle.mro_detail": "הסניף שלי - פרטים",
    "moduleTitle.nao_specific_info": "מידע רלבנטי - מפעיל ארצי (מטה)",
    "label.preparing_document_for_import": "מכין מסמכים לייבוא",
    "tasks.observations": "תצפיות",
    "notifications.confirmation_email_has_been_sent": "מייל אישור נשלח",
    "button.restore": "שחזור",
    "label.importing_file": "מייבא קובץ",
    "label.or_dont_agree": "האם הינך מסכים/ה או לא?",
    "moduleTitle.award_leader": "רכזי/ות אות הנוער",
    "label.me": "(אני)",
    "tabs.sub_global_operating_partners": "מפעילי משנה גלובאלי שותפים",
    "button.export_table": "ייצוא טבלה",
    "organisation.move_award_unit": "סניף הועבר",
    "label.file_category": "label.file_category",
    "notifications.connecting_to_server": "מתחבר לשרת...",
    "parentalConsent.i_understand_that_a_and_b": "11. לדעתי לא רלוונטי (יוסי)",
    "table.reason": "סיבה",
    "pageTitle.contacts": "אנשי קשר",
    "states.award_leader_approval": "אישור סופי של הרכז/ת",
    "meta.payments": "תשלומים",
    "label.suboperating_authority": "מפעלי משנה- שניים",
    "route.my_region_office": "אני שייך/ת למחוז",
    "states.registration_not_approved": "רישום לא אושר",
    "label.direct_entrant": "חניך/ה בכניסה ישירה לפעילות",
    "tabs.all_participants": "כל המשתתפים/ות",
    "tabs.payment": "תשלום",
    "label.email_help_activity_name": "שם הפעילות.",
    "title.update_report": "עדכן דוח",
    "label.repeat_new_password": "נא לחזור על הסיסמה החדשה",
    "label.other_roles": "ראה חוקים נוספים",
    "logs.hours": "שעות",
    "notifications.spreadsheet_has_been_imported_successfully": "טבלת מידע יצא בהצלחה",
    "label.bulk_action_question": "ביצוע של שינוי למספר של {count} פריטים?",
    "moduleTitle.personal_details": "פרטים אישיים",
    "label.bulk_action_emailing": "כתובות דואל של חניכים שנבחרו",
    "route.my_events": "האירועים שלי",
    "button.delete_award": "מחק אות",
    "errors.include_both_lower_and_upper_case": "יש לכלול אותיות גדולות וקטנות",
    "tabs.removed_participant_registrations": "הסר הרשמת משתתף",
    "sidebar.mynao": "המפעיל הארצי (מטה) שלי",
    "tabs.office_details": "פרטי משרד",
    "label.major": "ראשי",
    "tabs.documents": "מסמכים",
    "label.new_password": "סיסמה חדשה",
    "sidebar.adventure_journey": "מסע אתגרי",
    "pageTitle.customizations": "התאמות",
    "moduleTitle.assessor_report": "{role} דיווח",
    "label.registration_date": "תאריך רישום",
    "notifications.training_has_been_added": "אימון התווסף",
    "aj.qualifying": "עומד בדרישות",
    "moduleTitle.you_have_been_logged_out_session_terminated": "זמן השימוש תם ולכן המערכת נותקה",
    "award.service": "תרומה לקהילה\n",
    "notifications.rp_state_has_been_changed": "מדינת פרויקט קהילתי שונתה",
    "label.ctest_access": "גישה לCTEST",
    "table.created": "נוצר",
    "tasks.revise_task": "בקר/י משימה",
    "button.assign": "מנה/י",
    "button.return": "עריכה",
    "table.status": "סטטוס",
    "button.restore_activity": "השבת הפעילות מחדש",
    "tabs.new_aj_event": "מסע אתגרי - אירוע חדש",
    "roles.if_staff_viewer": "משתמש צופה אות",
    "notifications.new_template_has_been_created": "תבנית חדשה נוצרה",
    "global.something_went_wrong": "משהו השתבש",
    "table.expire_day": "תאריך תפוגה",
    "tabs.history_log": "היסטוריה של רישום",
    "label.form_of_payment": "צורת תשלום",
    "button.add_training": "הוסף/ הוסיפי הכשרה",
    "label.par_reg_cust_note": "כרטיסייה זו מאפשרת לך להתאים אישית שדות המוצגים ברישום החניכים ולהשפיע על כמות הנתונים שאתה אוסף. אנא צור קשר עם המטה הארגון אם ברצונך לבצע שינויים - רק למנהל המערכת של הארגון יש גישה לבצע שינויים אלה.",
    "label.my_qualification": "ההכשרה שלי",
    "button.add_new_profile_question": "להוספת שאלת פרופיל",
    "table.operating_authority": "מפעיל מאושר",
    "table.aim": "יעד",
    "table.awards": "אותות",
    "participant.deactivate_account": "הקפא/הקפיאי חשבון",
    "table.organization_name": "ארגון",
    "label.email_help_award_leader_first_name": "שם פרטי של מדריך/רכז.",
    "table.date": "תאריך",
    "tasks.would_you_like_to_delete": "את/ה מעוניין/ת בהסרת המשתתף/ת?",
    "notifications.configuration_value_has_been_updated": "ערך קונפיגורציה עודכן",
    "ajTemplates.fill_from_template": "עדכן/י מתבנית",
    "contact.send_test_email": "שלח הודעה אלקטרונית לבדיקה",
    "moduleTitle.aj_preparation_and_training": "הכנות והכשרות מסע אתגרי",
    "label.ce_be": "מיילים בהתאמה אישית (תרגום מיילים)",
    "button.notify_participant": "הודיע לחניך",
    "label.parent_phone": "מספר טלפון של הורה&#39;s/ אפוטרופוס&#39;s \n",
    "label.nao_regulations": "הנחיות NAO",
    "award.skills": "מיומנויות",
    "label.reject_application": "דחה את הטופס שהוגש",
    "leader.delete_account": "מחק חשבון",
    "table.assign": "מנה/י",
    "roles.aj_supervisor": "אחראי/ת מסע אתגרי",
    "label.logout": "התנתקות",
    "moduleTitle.award_leader_edit": "ערוך/כי רכז/ת",
    "moduleTitle.training": "הכשרה",
    "notifications.coordinator_has_been_removed": "הרכז/ת הוסר/ה",
    "tabs.operating_partners": "מפעילים שותפים",
    "moduleTitle.main_award_leader": "רכז/ת",
    "label.bulk_action_successful": "{count} של פריטים שונו בהצלחה",
    "tasks.clear_email_revision": "נקה בדיקה של מייל",
    "table.preparation": "הכנות",
    "table.delete": "מחק/י",
    "label.safeguarding_policy": "האות הבינלאומי לנוער נהלי מוגנות",
    "sidebar.reports": "דיווחים",
    "pageTitle.sub_global_operating_partners": "מפעילי משנה גולבאלי שותפים",
    "label.is_major_activity_confirmation": "לחניך יש תחום עיקרי קיים בשלב אות אחר, האם תרצה להוסיף תחום עיקרי נוסף?",
    "pageTitle.operating_authorities": "מפעלי משנה",
    "label.delete_participant_award_modal_question_detail": "האם אתה בטוח למחוק {awardLevel} עבור משתתף {participantId}.",
    "label.confirmed": "מאושר",
    "notifications.invitation_has_been_sent": "הזמנה נשלחה",
    "pageTitle.independent_countries": "מדינות עצמאיות",
    "label.assessors_email": "דואר אלקטרוני של מדריך/ה",
    "tasks.approve_assessor_registration": "הרשמה אושר על ידי הרכז",
    "table.award_duration": "משך פעילות בשלב הנוכחי",
    "notifications.organization_has_been_moved": "הסניף עבר",
    "pageTitle.nao_payment": "מפעיל ארצי (מטה) - תשלום",
    "participant.history_log": "היסטוריית רישומים",
    "label.rejected_with_note": "דחייה פעילות עם הערה: \"{note}\"",
    "label.already_running": "כבר פועל",
    "button.continue": "המשך",
    "award.no_data_to_show": "אין מידע להציג",
    "participant.send_email_invitation_again_question": "לשלוח שוב הודעת דוא\"ל לזימון?",
    "label.reason_for_changing_assessor": "סיבה לשינוי המדריך/כה",
    "button.delete": "מחק/י",
    "moduleTitle.requirements_and_conditions": "תנאים ודרישות מקדימות",
    "roles.leader": "מדריך/ה",
    "label.if_download_doesnt": "במידה והורדה לא מתרחשת אוטמטית, אנא בדוק את הגדרות הדפדפן שלך לפופ אפ",
    "dashboard.your_todo_list": "רשימת המשימות שלך",
    "notifications.award_unit_has_been_returned": "הסניף עבר בקרה",
    "moduleTitle.participant_activities": "פעילות של החניך/ה",
    "errors.qualification_or_experience_required": "דרושה הצגה של כישורים או ניסיון רלוונטי",
    "label.active_leaders": "מדריכים/ות פעילים/ות",
    "aj.preparation": "הכנה",
    "button.change_state": "שנה/י מצב",
    "label.current_password": "סיסמה נוכחית",
    "pageTitle.global_operating_partners": "מפעיל גלובאלי",
    "moduleTitle.contact_settings": "הגדרות אנשי/נשות קשר",
    "button.remove_photo": "הסר/הסירי תמונה",
    "notifications.activity_has_been_setup": "פעילות הוגדרה",
    "errors.must_be_more_than": "חייב להיות יותר מ {limit}",
    "table.goal": "יעד",
    "notifications.coordinator_has_been_set": "הוגדר/ה רכז/ת",
    "label.cc": "עותק",
    "label.duration": "משך",
    "table.actions": "פעולות",
    "participant.send_email_invitation_again": "לשלוח שוב הודעת דוא\"ל להזמנה?",
    "moduleTitle.would_you_like_to_remove_participant": "האם תרצה/י למחוק את הרשמת המשתתפ/ת?",
    "parentalConsent.i_authorise_employees": "הנני מאשר/ת לאפשר לכל בעל תפקיד מוסמך בארגון אות הנוער להגיש עזרה ראשונה לבני/בתי בכל מקרה של פציעה או תאונה, וכן להזמין עבורם סיוע רפואי כולל פינוי לאחות ו/או בית חולים במקרה חירום ",
    "button.reload_page": "הטען עמוד מחדש",
    "moduleTitle.update_translations": "עדכן תרגום פרויקט",
    "label.report_description": "שדות ועדכונים מופיעים כרגע בשפה האנגלית, אנו עובדים על פתרונות להצגת העידכונים בשפות נוספות.",
    "table.email": "דואר אלקטרוני",
    "label.new_goal": "יעד חדש",
    "label.participant_survey_parent": "",
    "errors.invalid_email_address": "כתובת דואר אלקטרוני שגויה",
    "pageTitle.new_contact": "איש/אשת קשר חדש/ה",
    "sidebar.gops": "GOPs",
    "button.manage_participants": "נהל/י משתתפים/ות",
    "errors.invalid_phone_format": "מספר טלפון לא תקין",
    "notifications.login_details_have_been_changed": "נתוני התחברות שונו",
    "moduleTitle.participant_logs": "רישומים של החניך/ה",
    "label.save": "שמור/שמרי",
    "label.frequently_asked_questions": "שאלות נפוצות (FAQs)",
    "label.city": "עיר",
    "notifications.configuration_value_has_been_reset": "הערך הכספי הוגדר מחדש",
    "states.office_sign_off": "מטה - אישור סופי",
    "button.save": "שמור/שמרי",
    "button.import_data_from_selected_file": "יצא מידע מתוך קבצים נבחרים",
    "parentalConsent.i_understand_that_the_participant_cannot": "לדעתי לא רלוונטי (יוסי)",
    "pageTitle.apiKeys": "Api Keys",
    "label.international_region": "מחוז בינלאומי",
    "tabs.levels": "שלבים",
    "tabs.additional_files": "קבצים נוספים",
    "label.continuation_level": "שלב מתמשך",
    "table.adventurous_journey_detail": "פרטים",
    "button.set": "הגדר",
    "label.i_certify_that_as_the_assessor": "אני מאשר כ{role} של הפעילות שהמשתתף/ת ענה/ענתה על הדרישות",
    "table.coordinator": "רכז/ת",
    "participant.send_confirmation_email_again": "שליחת מייל אישור בשנית?",
    "table.report": "דיווח",
    "label.update_translations_results": "תוצאות עדכון התרגום",
    "table.observation_note": "הערת תצפית",
    "label.view_more": "ראה/י עוד ",
    "notifications.payment_link_has_been_reset": "הקישור לתשלום אופס מחדש",
    "table.type": "סוג",
    "moduleTitle.updateConfigurationKey": "עדכון לחצן תצורה",
    "sidebar.independent_award_centers": "סניפים עצמאיים",
    "table.activity_type": "סוג הפעילות",
    "label.awardMode.online": "מקוון",
    "table.data_state": "רענון מידע אחרון",
    "button.generate_report": "צור דיווח",
    "moduleTitle.assessed_by_award_leader": "הוערכ/ה ע\"י מדריך/ה רכז/ת",
    "table.child_protection_number": "מספר הגנת ילדים",
    "button.bulk_change": "שנה לכולם",
    "label.send_welcome_email": "שלח מייל קבלה",
    "label.award_state": "סטטוס האות",
    "moduleTitle.overview": "סקירה",
    "table.aj_detail": "מסע אתגרי - מידע",
    "pageTitle.tasks_activity_approvals": "אישור פעילות",
    "label.section": "מקטע",
    "route.history": "היסטוריה",
    "route.event_participants": "משתתפים/ות באירוע",
    "participant.account_detail": "הגדרות החשבון",
    "route.dashboard": "תצוגת נתונים ראשית",
    "table.payments": "תשלומים",
    "pageTitle.profile": "פרופיל",
    "organisation.remove_organisation": "הסר ארגון",
    "pageTitle.my_organization": "הארגון שלי",
    "label.award_leader": "מדריכ/ה רכז",
    "notifications.assessor_has_been_updated": "עדכון מדריך/ה",
    "label.participant_personal_reflection": "הערות אישיות של החניך",
    "button.add_key": "הוסף תא",
    "header.appMotto": "דוכס",
    "table.qualifying": "עומד בדרישות",
    "button.upload": "העלאת קובץ",
    "button.resend": "לשליחה מחדש",
    "label.filename": "שם קובץ",
    "label.change_parental_consent": "שנה הסכמת הורים",
    "button.cancel": "בטל/י",
    "label.aply_to_all_langs": "החל על כל השפות",
    "route.customization": "התאמה אישית",
    "errors.minimal_duration_is": "משך מינימלי הוא 30 דקות",
    "label.email_help_participant_first_name": "שם פרטי חניך.",
    "label.participant_status": "סטטוס משתתפ/ת",
    "award.bronze_level_short": "ארד",
    "label.phone_type": "סוג מכשיר טלפון",
    "global.night": "ימים",
    "button.adventurous_journey_settings": "הגדרות מסע אתגרי",
    "participant.leader_must_be_selected": "יש לבחור מדריך/ה",
    "pageTitle.translationsManagement": "ניהול תרגומים",
    "moduleTitle.user_added_preparation_and_training": "משתמש/ת הוסיף/ה הכשרות ואימונים",
    "table.approve": "אשר/י",
    "label.role_in_organisation": "תפקיד בארגון",
    "states.finished": "סיים/מה",
    "label.created": "נוצר/ה",
    "button.back_to_home": "חזרה לעמוד הבית",
    "label.options": "אפשרויות",
    "contact.next_level_invitation": "הזמנה לעליית שלב",
    "moduleTitle.activity_detail": "פרט פעילות",
    "route.section_signoff": "אישור מקטע",
    "moduleTitle.assign_labels_bulk": "הקצה תגיות שנבחרו ל${itemCount} חניכים.",
    "button.contact_settings": "הגדרות איש/אשת קשר",
    "label.transation_id": "מזהה העברה",
    "notifications.activity_has_been_updated": "פעילות עודכנה",
    "sidebar.awards": "אותות",
    "parentalConsent.images_consent": "כהורה/ אפוטרופוס אני מאשר לארגון לעשות שימוש בתמונות לצרכים שיווקיים",
    "participant.would_you_like_to_delete": "למחוק את החשבון?",
    "roles.user": "משתמש/ת",
    "label.label": "תג",
    "label.select_sheet": "בחר גיליון מהמחשב",
    "global.no_results": "אין תוצאות",
    "moduleTitle.address_line_2": "כתובת - שורה שניה",
    "states.awaiting_office_sign_off": "ממתין לאישור סופי מהמטה",
    "moduleTitle.export": "ייצוא ",
    "moduleTitle.address_line_1": "כתובת - שורה ראשונה",
    "notifications.participant_has_been_assigned": "משתתף/ת צורף/ה",
    "roles.viewer": "צופה",
    "label.participants_total": "סך משתתפים/ות",
    "errors.auth_code_is_no_longer_valid": "קוד אישור אינו בתוקף- נעשה שימוש בקוד או שתוקפו פג",
    "label.file_is_not_available": "קובץ לא זמין",
    "button.select_template": "בחירת תבנית",
    "label.payment": "תשלום",
    "award.silver_level_short": "כסף",
    "table.participant_id": "מס\"ד חניך",
    "text.hours_old": "{hours} שעות",
    "moduleTitle.your_personal_information": "מידע אישי",
    "aj.minimum_date_recommendation": "תאריך מינימלי מומלץ למסע אימון ו {name} הוא ",
    "label.date_of_payment": "תאריך תשלום",
    "button.view": "לצפיה",
    "label.create_new_label": "צור תגית חדשה",
    "title.confirmation": "אישור",
    "button.set_participants": "הגדר משתתפים/ות",
    "roles.assessor": "מדריך/ה",
    "moduleTitle.coordinator_settings": "הגדרות לרכז/ת",
    "label.parent_relationship": "הורה&39#;ים יחסים",
    "table.nao": "מפעיל ארצי - מפ\"א (מטה)",
    "notifications.email_has_been_sent": "הודעת דואר אלקטרוני נשלחה",
    "label.email_help_participant_full_name": "שם מלא חניך.",
    "sidebar.suboperating_authorities": "סמכויות משנה מפעילות",
    "route.award": "אות",
    "label.no_roles": "אין כללים",
    "table.files": "תקיות",
    "aj.minimum_date_requirements": "תאריך מינימום להתאמה בעבור (name) הוא",
    "pageTitle.labels": "תגיות",
    "label.participant_is_semi_offline": "משתתף לא זמין",
    "moduleTitle.other_coordinators": "רכזים נוספים",
    "button.updateSelectedLanguage": "button.עדכן בחירת שפה",
    "tasks.approve_award_registration": "אשר/י רישום לאות הנוער",
    "participant.invite_participant_to_next_level": "להזמין את החניך/כה לשלב הבא?",
    "label.twitter": "טוויטר",
    "pageTitle.awards": "אותות",
    "warning.award_marked_as_paid": "אזהרה: ישנה לפחות הרשמה אחת לאות המסומנת כמשולמת. אנא פנה להנחיות החזר כספי לפני אישור המחיקה של החניך.",
    "table.edit": "ערוך/ערכי",
    "states.change_to_state_warning_missing_hours_to_complete": "אזהרה: כמות השעות המינימאלית הנדרשת לא נרשמה. האם להמשיך?",
    "label.dofe": "האות הבינלאומי",
    "moduleTitle.after_assigning_a_role_to_yourself": "לאחר שינוי או הגדרה של תפקיד תדרש להתחבר מחדש",
    "label.transaction_id": "מזהה העברה",
    "table.suboperating_authority": "תת מפעיל מאושר",
    "label.participant_survey": "כחניך באות הנוער אשמח להשתתף בסקרים של הארגון הבינלאומי",
    "label.created_by": "נוצר/ה על ידי",
    "button.send_confirmation_email_again_question": "שליחה אישור במייל מחדש",
    "label.email_help_award_leader_email": "דוא\"ל מדריך/רכז.",
    "label.name": "שם",
    "tabs.gold_level": "שלב הזהב",
    "pageTitle.award_documents": "מסמכי האות",
    "label.online_payments": "תשלום מקוון",
    "label.child_protection_number": "מספר הגנת ילדים",
    "participant.send_password_recovery_email": "לשלוח חידוש סיסמה?",
    "notifications.new_log_has_been_added": "רישום חדש הוסף",
    "moduleTitle.add_gop_role": "הוסף מפעיל או מפעיל משנה",
    "label.organization_name": "שם ארגון",
    "pageTitle.my_organization_templates": "הארגון שלי - תבניות",
    "pageTitle.award_leaders": "מדריכים/ות",
    "label.status": "מצב",
    "label.street": "רחוב",
    "roles.if_staff_superuser": "משתמש ארגון בינלאומי",
    "table.licence_holder": "בעל/ת רשיון",
    "label.created_at": "נוצר ב",
    "table.section": "מקטע",
    "table.system_rights": "זכויות מערכת",
    "label.iac_type": "סוג IAC",
    "label.other": "אחרים",
    "moduleTitle.login": "התחבר/י",
    "label.no_data_to_show": "אין נתונים להציג",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "לא ניתן לעדכן שלב ב'אות' אם חניכים משויכים",
    "tabs.waiting_payments": "תשלומים שעוכבו",
    "global.supervisor": "אחראי/ת",
    "notifications.new_role_has_been_added": "תפקיד חדש נוסף",
    "award.silver_level": "שלב הכסף",
    "heading.change_awards_mode": "שנה מצב אות",
    "button.save_changes": "שמור/י שינויים",
    "organisation.would_you_like_to_move_award_unit": "האם תרצה להסיר ארגון זה?",
    "label.fields": "תווית.שדות",
    "label.email_help_organization_name": "שם הסניף.",
    "pageTitle.mro_related_detail": "הסניף שלי - פרטים",
    "table.started_at": "התחיל/ה ב",
    "parentalConsent.i_consent_to_the_award_unit": "2. הנני מאשר/ת לבני/בתי להשתתף בכל פעילות סניף אות הנוער, וכן השתתפות מלאה בפעילות חינוכיות מחוזיות ו/או ארציות, כגון טקסים, סמינרים ומסעות. אני מודע לכך שבכל פעילות מחוץ ליישוב ייצא עדכון וחוזר להורים מראש.  ",
    "logs.minutes": "דקות",
    "label.total_participants": "סך המשתתפים/ות",
    "moduleTitle.contact_info": "מידע ליצירת קשר",
    "table.payment_link": "קישור לתשלום",
    "errors.please_contact_your_local_award_staff": "בבקשה צור קשר עם איש צוות האות באזורך"
}